/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    TaxpayerAccDetailsActions,
    fetchTaxpayerAccDetailsSuccessAction,
    fetchTaxpayerAccHomeDataErrorAction,
    fetchTaxpayerAccCashboxesStatsSuccessAction,
    TaxpayerAccDetailsActionType,
} from '../../actions/TaxpayerAcc/TaxpayerAccDetailsActions';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { companiesClient } from '../../api/companies/companiesClient';
import { AxiosError } from 'axios';
import { parseError } from '../../../utils/utils';
import { i18n } from '../../translation/i18n';

export const getTaxpayerAccDetailsEpic: Epic<TaxpayerAccDetailsActions> = (action$) => {
    return action$.pipe(
        ofType(TaxpayerAccDetailsActionType.OPEN_TAXPAYER_ACC_HOME_PAGE),
        switchMap(() => {
            return from(companiesClient.getTaxpayerAccHomeData()).pipe(
                map((resp) => fetchTaxpayerAccDetailsSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchTaxpayerAccHomeDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.taxpayerDataNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(TaxpayerAccDetailsActionType.EXIT_TAXPAYER_ACC_HOME_PAGE)),
            );
        }),
    );
};

export const getTaxpayerAccCashBoxesStatsEpic: Epic<TaxpayerAccDetailsActions> = (action$, state$) => {
    return action$.pipe(
        ofType(TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_DETAILS_SUCCESS),
        switchMap(() => {
            const companyTaxNumber = state$.value.taxpayerAccDetailsReducer.companyDetails.taxNumber;

            return from(companiesClient.getCompanyCashBoxesStats(companyTaxNumber)).pipe(
                map((resp) => {
                    return fetchTaxpayerAccCashboxesStatsSuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchTaxpayerAccHomeDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashBoxesStatsNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(TaxpayerAccDetailsActionType.EXIT_TAXPAYER_ACC_HOME_PAGE)),
            );
        }),
    );
};
